import React, {Component} from "react";
import MenuBar from "./MenuBar";
import NavBar from "./NavBar";

interface PropsContract {
  contentChild: React.ReactNode
}

export default class PageContainer extends Component<PropsContract> {
  render() {
    return (
      <>
        {/* info bar */}
        <div className="art-info-bar">

          {/* menu bar frame */}
          <MenuBar/>
          {/* menu bar frame end */}

        </div>
        {/* info bar end */}

        {/* content */}
        { this.props.contentChild }
        {/* content end */}

        {/* menu bar */}
        <NavBar
          currentMenuItem={'home'}
        />
        {/* menu bar end */}
      </>
    )
  }
}
